import * as React from 'react';
import { navigate } from 'router';

import CurrentOrgInjector from '~/apps/shared/containers/app/CurrentOrgInjector';
import OrgUserHeader from '~/apps/shared/containers/users/OrgUserHeader';


export default function() {
  return (
    <CurrentOrgInjector
      component={OrgUserHeader}
      onCreate={() => navigate('sender.settings.team.create')}
    />
  );
};
